const CREDIT_LIMIT = 'credit-limit'
const CREDIT_CARD = 'cc'
const BANKING_B2C = 'b2c'
const BANKING_B2B = 'b2b'
const EWALLET = 'ewallet'

module.exports = { CREDIT_LIMIT, CREDIT_CARD, BANKING_B2C, BANKING_B2B, EWALLET }
